import type React from 'react';
import { createContext, useContext } from 'react';

// Set inside the update flow, which moves a record to the latest version through its draft
const InstitutionDetailsUpdateContext = createContext(false);

export const InstitutionDetailsUpdateProvider = ({ children }: React.PropsWithChildren) => {
  return <InstitutionDetailsUpdateContext.Provider value>{children}</InstitutionDetailsUpdateContext.Provider>;
};
InstitutionDetailsUpdateProvider.displayName = 'InstitutionDetailsUpdateProvider';

export const useIsInstitutionDetailsUpdate = () => useContext(InstitutionDetailsUpdateContext);

const INSTITUTION_ONBOARDING_PATH = '/institution/onboarding';

const INSTITUTION_ONBOARDING_UPDATE_PATH = '/institution/onboarding/update';

export const useInstitutionOnboardingBasePath = () => (useIsInstitutionDetailsUpdate() ? INSTITUTION_ONBOARDING_UPDATE_PATH : INSTITUTION_ONBOARDING_PATH);
